import { ListPageSkeleton } from '@practium/ui';

export const ProductRequestsPageSkeleton = () => (
	<ListPageSkeleton
		tabsCount={4}
		headerActionsCount={1}
		tableRows={8}
		tableCols={6}
		sidebarWidth="27rem"
		sidebarW1500="22rem"
		sidebarW1300="19rem"
		sidebarW1200="17rem"
	/>
);
